/**
 * Which build of the built-in prop library to load. The values double as the accepted values of
 * the `propLibrary` URL parameter, so renaming them invalidates existing links.
 */
export enum PropLibrarySource {
  GIT = "git",
  AWS = "aws",
  REVIEW = "review",
}

/**
 * Maps a `propLibrary` URL parameter value to a source, falling back to the git library for
 * missing or unrecognized values.
 */
export function propLibrarySourceFromString(value: string | null | undefined): PropLibrarySource {
  switch (value) {
    case PropLibrarySource.GIT:
      return PropLibrarySource.GIT;
    case PropLibrarySource.REVIEW:
      return PropLibrarySource.REVIEW;
    default:
      return PropLibrarySource.AWS;
  }
}

export function reloadWithPropLibraryURLParam(source: PropLibrarySource) {
  const params = new URLSearchParams(window.location.search);
  params.set("propLibrary", source);
  const queryString = params.toString();
  // Need a hard reload for the changes to take effect.
  window.location.href = `${window.location.pathname}${queryString ? `?${queryString}` : ""}`;
}
